/** @format */

import { Cookies } from "react-cookie";
export const cookies = new Cookies("global", { path: "/" });
